import React from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import SurveyAnswerInputNumber from "./survey-answer-input-number";
import SurveyAnswerInputDate from "./survey-answer-input-date";
import SurveyAnswerSelect from "./survey-answer-select";
import SurveyAnswerOptions from "./survey-answer-options";
import SurveyAnswerWaistParts from "./survey-answer-waist-parts";
import { editButtons, editButtonSave, editButtonCancel } from "./survey-answer-question-card.module.scss";
import SurveyAnswerSkirtLength from "./survey-answer-skirt-length";
import SurveyAnswerBodyParts from "./survey-answer-body-parts";

export interface ISurveyAnswerQuestionCardEditProps {
    question: ISurveyQuestion;
    value: string | number | Array<string | number> | null;
    onChange: (value: string | number | Array<string | number>) => void;
    onSave: (value?: string | number | Array<string | number>, shouldClose?: boolean) => void;
    onCancel: () => void;
}

const SurveyAnswerQuestionCardEdit: React.FC<ISurveyAnswerQuestionCardEditProps> = ({
    question,
    value,
    onChange,
    onSave,
    onCancel,
}) => {
    const { inputType } = question;

    const renderInput = () => {
        // Sprawdź customComponentWww (może być w question jako dodatkowe pole)
        const customComponent = (question as any).customComponentMobile; //zawsze jednak tak!!!
        
        if (customComponent === "WaistPartsQuestion") {
            return (
                <SurveyAnswerWaistParts
                    question={question}
                    value={value as string | number | Array<string | number> | null}
                    onChange={onChange}
                    onSave={onSave}
                />
            );
        }
        if (customComponent === "SkirtLengthQuestion") {
            return (
                <SurveyAnswerSkirtLength
                    question={question}
                    value={value as string | number | Array<string | number> | null}
                    onChange={onChange}
                    onSave={onSave}
                />
            );
        }
        if (customComponent === "BodyPartsQuestion") {
            return (
                <SurveyAnswerBodyParts
                    question={question}
                    value={value as string | number | Array<string | number> | null}
                    onChange={onChange}
                    onSave={onSave}
                />
            );
        }
        switch (inputType) {
            case "number":
                return (
                    <SurveyAnswerInputNumber
                        question={question}
                        value={value as string | number | null}
                        onChange={onChange}
                    />
                );
            case "date":
                return (
                    <SurveyAnswerInputDate
                        question={question}
                        value={value as string | null}
                        onChange={onChange}
                    />
                );
            case "select":
                return (
                    <SurveyAnswerSelect
                        question={question}
                        value={value as string | number | null}
                        onChange={onChange}
                        onSave={onSave}
                    />
                );
            case "checkbox":
            case "radio":
                return (
                    <SurveyAnswerOptions
                        question={question}
                        value={value as string | number | Array<string | number> | null}
                        onChange={onChange}
                        isMulti={inputType === "checkbox"}
                        onSave={onSave}
                    />
                );
            default:
                return null;
        }
    };

    const inputComponent = renderInput();
    const isAutoSaveType = false; // inputType === "checkbox" || inputType === "radio" || inputType === "select";

    return (
        <>
            {inputComponent || <div>Brak komponentu dla typu: {inputType}</div>}
            {!isAutoSaveType && (
                <div className={editButtons}>
                    <button type="button" onClick={() => onSave()} className={editButtonSave}>
                        Zapisz
                    </button>
                    <button type="button" onClick={onCancel} className={editButtonCancel}>
                        Anuluj
                    </button>
                </div>
            )}
        </>
    );
};

export default SurveyAnswerQuestionCardEdit;
